












import Vue from 'vue';
import {
  mapState,
  mapActions
} from 'vuex';
import store from '../store/index';
import config from '../config/index';
import Simple from './Simple.vue';
import OriginalText from './OriginalText.vue';
import DetailPart from './DetailPart.vue';
import FullText from './FullText.vue';
import Preservation from './Preservation.vue';
import OneToOne from './OneToOne.vue'; 
import { Backtop } from 'element-ui';

// // 模板文件只打包全文组件
// let Simple: any;
// let OriginalText: any;
// let DetailPart: any;
// let Preservation: any;
// let component: any = {
//   FullText
// };
// if (config.env !== 'template') {
//   Simple = require('./Simple.vue').default;
//   OriginalText = require('./OriginalText.vue').default;
//   DetailPart = require('./DetailPart.vue').default;
//   Preservation = require('./Preservation.vue').default;
//   component = {
//     Simple,
//     OriginalText,
//     DetailPart,
//     FullText,
//     Preservation
//   };
// }
export default Vue.extend({
  name: 'Report',
  computed: mapState({
    reportType: (state: any) => store.getters.getReportType,
    checkType: (state: any) => store.getters.getCheckType,
  }),
  components: {
    Simple,
    OriginalText,
    DetailPart,
    FullText,
    Preservation,
    OneToOne,
    'el-backtop': Backtop
  },
  data() {
    return {
      order: config.order
    };
  },
  methods: {
  }
});
